import { PopupPropsContext } from "@progress/kendo-react-popup";
import "@progress/kendo-theme-default/dist/all.css";
import _ from "lodash";
import * as React from "react";
import {
    HashRouter, Route, Switch,
} from "react-router-dom";
import "../../../node_modules/font-awesome/scss/font-awesome.scss"; // Font-Awesome SASS CSS sheet.
import "../common/styles/presenceFramework.css";
import Edit from "./components/Edit";
import Post from "./components/Post";
import Posts from "./components/Posts";
import Settings from "./components/Settings";
import { IConfig } from "./Config";
import "./newsroom.css";
import { NewsroomView, ViewType } from "./NewsroomView";

import { EnviroConfig } from "../EnviroConfig";

interface IProps extends React.Props<Newsroom> {
    cdnLocation: string;
    config: string;
}

interface IState {
    config: IConfig;
    savedStateForPosts: any;
    textFromService: string;
}

export default class Newsroom extends React.Component<IProps, IState> {
    public constructor(props, context) {
        super(props, context);
        const config = JSON.parse(props.config) || {};
        config.cdnLocation = !_.isEmpty(props.cdnLocation) ? `${window.location.protocol}//${_.trimEnd(props.cdnLocation, "/")}` : "";

        const enviro = new EnviroConfig();
        if (!config.newsroomServiceURL || config.newsroomServiceURL.length === 0) {
            config.newsroomServiceURL = enviro.newsroomServiceURL;
            config.newsroomApiBaseUrl = enviro.newsroomApiBaseUrl;
        }

        this.state = {
            config,
            savedStateForPosts: null,
            textFromService: "Loading...",
        };
    }

    public render() {
        return (
            <PopupPropsContext.Provider
                value={(props) => ({ ...props })}
            >
                {this.state.config.mode === "settings"
                    ? <Settings config={this.state.config} />
                    : (
                        (this.state.config.isAllFeeds === false && _.isEmpty(this.state.config.feedIds)) ?
                            <p style={{ textAlign: "center" }}>No feed is configured</p>
                            : <HashRouter>
                                <Switch>
                                    <Route path="/" exact={true}>
                                        <NewsroomView
                                            config={this.state.config}
                                            initialView={ViewType.Summary}
                                        />
                                    </Route>
                                    <Route path={`/${this.state.config.portletInstanceId}/create`} exact={true}>
                                        <NewsroomView
                                            config={this.state.config}
                                            initialView={ViewType.EditForm}
                                            newsId={null}
                                        />
                                    </Route>
                                    <Route path={`/${this.state.config.portletInstanceId}/edit/:newsId`}
                                        render={(rc) =>
                                            <NewsroomView
                                                config={this.state.config}
                                                initialView={ViewType.EditForm}
                                                newsId={rc.match.params.newsId}
                                            />
                                        }
                                    />
                                    <Route path={`/${this.state.config.portletInstanceId}/read/:readMode/f/:friendlyUrl`}
                                        render={(rc) =>
                                            <NewsroomView
                                                config={this.state.config}
                                                initialView={ViewType.Details}
                                                isViewingArchivedItems={rc.match.params.readMode === "archived"}
                                                friendlyUrl={rc.match.params.friendlyUrl}
                                            />
                                        }
                                    />
                                    <Route path={`/${this.state.config.portletInstanceId}/settings`}>
                                        <Settings config={this.state.config} />
                                    </Route>
                                </Switch>
                            </HashRouter>
                    )
                }
            </PopupPropsContext.Provider>
        );
    };

    private saveStateForPosts = (stateForPosts: any) => {
        this.setState({ savedStateForPosts: stateForPosts });
    }
};
